import { AxiosError, AxiosResponse } from 'axios';
import useSWR, { mutate } from 'swr';

import Config from '../../shared/config';
import { ModuleCertificateModel } from '../models/ModuleCertificateModel';

export function useModuleProgress(userkey: number) {
  const url = userkey
    ? `${Config.API}/api/certificate/module/list/user/${userkey}/progress`
    : null;

  const {
    isLoading,
    data: response,
    error
  } = useSWR<AxiosResponse<ModuleCertificateModel[]>, AxiosError<Error>>(url);
  const refetchModulesProgress = async () => {
    await mutate(url);
  };

  return {
    loadingProgress: isLoading,
    progressError: error,
    modulesProgress: response?.data,
    refetchModulesProgress
  };
}
